import React, {useState, useEffect} from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {useMediaQuery, useTheme} from '@mui/material';
import Stack from '@mui/material/Stack';
import Doughnutchart from '../Doughnutchart';
import {LowerComponent} from '../LowerComponent';
import {Language} from '../../context/LanguageContext';
import {numberWithCommas} from '../../Helpers/stringFormat';
import {IconPesertaLot} from '../../assets';

function formatLabel(label) {
  const regex = /^(B|Blok|Block)\s*(\d{1,3})$/;
  const match = label.match(regex);
  if (match) {
    const digits = parseInt(match[2]);
    return match[1] === 'Blok' && `B${digits}`;
  } else {
    return label;
  }
}

function formatBlokLabel(label) {
  const regex = /^(B|Blok|Block)\s*0*(\d{1,3})$/;
  const match = label.match(regex);
  if (match) {
    const digits = parseInt(match[2], 10).toString();
    return match[1] === 'Blok' && `Blok ${digits}`;
  } else {
    return label;
  }
}

export default function DataContainerTab(props) {
  const {language, newObj} = Language();
  useEffect(() => {
    setTempSelectedGroupName(props.selectedGroupName);
  }, [props]);

  const [value, setValue] = useState(0);
  const [tempSelectedGroupName, setTempSelectedGroupName] = useState(
    props.selectedGroupName
  );

  const theme = useTheme();

  const [doughnutData, setDoughnutData] = useState({
    labels: ['Luas Berhasil', 'Luas Bertanam'],
    datasets: [
      {
        label: 'Data ',
        data: [
          props?.data?.summary?.luas_berhasil,
          props?.data?.summary?.luas_bertanam,
        ],
        backgroundColor: ['rgba(43, 51, 125, 1)', 'rgba(226, 31, 38, 1)'],
        borderColor: ['rgba(43, 51, 125, 1)', 'rgba(226, 31, 38, 1)'],
        borderWidth: 1,
      },
    ],
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
    props.onData(newValue);
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    aspectRatio: 1,
    width: '100%',
    plugins: {
      legend: {
        display: false, // set this to false to hide the legend
      },
    },
  };

  const isXsScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  function InnerComponent(props) {
    const filteredData = props.data.data.data.filter((obj) => {
      return obj.title === tempSelectedGroupName;
    });
    return (
      <Grid
        container
        component='main'
        style={{
          margin: 0,
        }}
      >
        {filteredData.length > 0
          ? filteredData[0]?.features
              .sort((a, b) => {
                const labelA = a?.properties[0]?.label;
                const labelB = b?.properties[0]?.label;
                if (labelA < labelB) {
                  return -1;
                }
                if (labelA > labelB) {
                  return 1;
                }
                return 0;
              })
              .map((smaller, index) => (
                <div
                  key={index}
                  style={{
                    padding: '25px',
                    borderBottom: '1px solid lightgrey',
                    borderTop: '1px solid lightgrey',
                  }}
                >
                  {/* biar ga error sementara */}
                  {smaller.properties && (
                    <>
                      {' '}
                      <Grid
                        key={smaller.id}
                        sx={{
                          height: 'fit-content',
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: '10px',
                          flexDirection: 'row',
                          marginBottom: '15px',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          props.data.mapRef.current.eachLayer(function (layer) {
                            if (
                              layer['feature']?.featureId ===
                              smaller?.feature_id
                            ) {
                              layer.setStyle({
                                fillColor: '#00ffff40',
                                color: 'rgba(0, 255, 255, 2)',
                              });
                              setTimeout(() => {
                                layer.setStyle({
                                  fillColor: 'rgba(255,158,23,255)',
                                  color: 'rgba(255,158,23,255)',
                                });
                              }, 3000);
                              const {lat, lng} = layer.getCenter();
                              props.data.mapRef.current.flyTo(
                                [lat, lng],
                                props.data.mapRef.current.getZoom()
                              );
                            }
                          });
                        }}
                      >
                        <div
                          style={{
                            color: 'white',
                            padding: '10px',
                            backgroundColor: 'black',
                            borderRadius: '100%',
                          }}
                        >
                          {formatLabel(smaller?.properties[0]?.label)}
                        </div>
                        <div style={{fontWeight: 'bold'}}>
                          {formatBlokLabel(smaller.properties[0]?.label)}
                        </div>
                      </Grid>
                      <Grid
                        container
                        component='main'
                        sx={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Grid container component='main' sx={{width: '100%'}}>
                          {/* LUAS LADANG */}
                          <Grid
                            item
                            xs={6}
                            style={{
                              fontSize: '12px',
                              padding: '4px',
                            }}
                          >
                            <div variant='caption' style={{fontSize: '12px'}}>
                              {newObj.LuasLadangWord[language]}
                            </div>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            style={{
                              fontSize: '12px',
                              padding: '4px',
                              fontWeight: 'bold',
                            }}
                          >
                            <Stack
                              direction='row'
                              spacing={2}
                              alignItems='center'
                            >
                              <div variant='caption' style={{fontSize: '12px'}}>
                                {numberWithCommas(
                                  smaller?.properties[0]?.luas_ladang_ha
                                )}{' '}
                                ha /
                                {numberWithCommas(
                                  smaller?.properties[0]?.luas_ladang_ac
                                )}{' '}
                                ac
                              </div>
                            </Stack>
                          </Grid>
                          {props.data.menu === 0 && (
                            <>
                              {/* LUAS BERHASIL */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  {newObj.LuasBerhasilWord[language]}
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                  fontWeight: 'bold',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{fontSize: '12px'}}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.luas_berhasil
                                    )}{' '}
                                    ha
                                  </div>
                                </Stack>
                              </Grid>
                              {/* Bilangan Pokok */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Bilangan Pokok
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                  fontWeight: 'bold',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{fontSize: '12px'}}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.bilangan_pokok
                                    )}
                                  </div>
                                </Stack>
                              </Grid>
                              {/* SPH */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  SPH
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                  fontWeight: 'bold',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{fontSize: '12px'}}
                                  >
                                    {smaller?.properties[0]?.sph}
                                  </div>
                                </Stack>
                              </Grid>
                              {/* Jenis Tanaman */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Jenis Tanaman
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                  fontWeight: 'bold',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{fontSize: '12px'}}
                                  >
                                    {smaller?.properties[0]?.jenis_tanaman?.join(
                                      ', '
                                    )}
                                  </div>
                                </Stack>
                              </Grid>
                            </>
                          )}
                          {props.data.menu === 1 && (
                            <>
                              {/* LUAS JALAN */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Luas Jalan
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.luas_jalan
                                    )}{' '}
                                    ha
                                  </div>
                                </Stack>
                              </Grid>

                              {/* KEPADATAN JALAN */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Kepadatan Jalan
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.kepadatan_jalan
                                    )}{' '}
                                    m/ha
                                  </div>
                                </Stack>
                              </Grid>
                              <br />
                              <br />
                              {/* JALAN DALAM BLOK */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Jalan Dalam Blok
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.jalan_dalam_blok
                                    )}{' '}
                                    m
                                  </div>
                                </Stack>
                              </Grid>

                              {/* JALAN UTAMA */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Jalan Utama
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.jalan_utama
                                    )}{' '}
                                    m
                                  </div>
                                </Stack>
                              </Grid>

                              {/* JALAN LADANG */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Jalan Ladang
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.jalan_ladang
                                    )}{' '}
                                    m
                                  </div>
                                </Stack>
                              </Grid>
                            </>
                          )}
                          {props.data.menu === 2 && (
                            <>
                              {/* LUAS TIDAK USAHA */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Luas Tidak Usaha
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.luas_tidak_usaha
                                    )}{' '}
                                    ha
                                  </div>
                                </Stack>
                              </Grid>
                              {/* JALAN */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Luas Jalan
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                  fontWeight: 'bold',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{fontSize: '12px'}}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.jalan
                                    )}{' '}
                                    ha
                                  </div>
                                </Stack>
                              </Grid>
                              {/* MAJU LUAR KAWASAN */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  Maju Luar Kawasan
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                  fontWeight: 'bold',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{fontSize: '12px'}}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.maju_luar_kawasan
                                    )}{' '}
                                    ha
                                  </div>
                                </Stack>
                              </Grid>
                              {/* LUAS BERHASIL */}
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                }}
                              >
                                <div
                                  variant='caption'
                                  style={{fontSize: '12px'}}
                                >
                                  {newObj.LuasBerhasilWord[language]}
                                </div>
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{
                                  fontSize: '12px',
                                  padding: '4px',
                                  fontWeight: 'bold',
                                }}
                              >
                                <Stack
                                  direction='row'
                                  spacing={2}
                                  alignItems='center'
                                >
                                  <div
                                    variant='caption'
                                    style={{fontSize: '12px'}}
                                  >
                                    {numberWithCommas(
                                      smaller?.properties[0]?.luas_berhasil
                                    )}{' '}
                                    ha
                                  </div>
                                </Stack>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </>
                  )}
                </div>
              ))
          : null}
      </Grid>
    );
  }

  useEffect(() => {
    if (props.menu === 0) {
      setDoughnutData({
        labels: ['Luas Berhasil', 'Luas Bertanam'],
        datasets: [
          {
            label: 'Data ',
            data: [
              props?.data?.summary?.luas_berhasil,
              props?.data?.summary?.luas_bertanam,
            ],
            backgroundColor: ['rgba(43, 51, 125, 1)', 'rgba(226, 31, 38, 1)'],
            borderColor: ['rgba(43, 51, 125, 1)', 'rgba(226, 31, 38, 1)'],
            borderWidth: 1,
          },
        ],
      });
    } else if (props.menu === 1) {
      setDoughnutData({
        labels: ['Luas Jalan', 'Luas Ladang'],
        datasets: [
          {
            label: 'Data ',
            data: [
              props?.data?.summary?.luas_jalan,
              props?.data?.summary?.luas_ladang_ha,
            ],
            backgroundColor: ['rgba(43, 51, 125, 1)', 'rgb(199,199,199)'],
            borderColor: ['rgba(43, 51, 125, 1)', 'rgb(199,199,199)'],
            borderWidth: 1,
          },
        ],
      });
    } else if (props.menu === 2) {
      setDoughnutData({
        labels: ['Luas Tidak Usaha', 'Jalan', 'Luas Ladang'],
        datasets: [
          {
            label: 'Data ',
            data: [
              props?.data?.summary?.luas_tidak_usaha,
              props?.data?.summary?.jalan,
              props?.data?.summary?.luas_ladang_ha,
            ],
            backgroundColor: [
              'rgba(43, 51, 125, 1)',
              'rgba(226, 31, 38, 1)',
              'rgb(199,199,199)',
            ],
            borderColor: [
              'rgba(43, 51, 125, 1)',
              'rgba(226, 31, 38, 1)',
              'rgb(199,199,199)',
            ],
            borderWidth: 1,
          },
        ],
      });
    }
  }, [props.data]);
  return (
    <Box>
      {/* <Tabs
        centered
        value={value}
        onChange={handleChange}
        style={{
          borderBottom: '1px solid lightgrey',
        }}
      >
        <Tab
          label='Dirian Pokok'
          value={0}
          sx={{
            background: 'transparent',
          }}
        />
        <Tab
          label='Jalan'
          value={1}
          sx={{
            background: 'transparent',
          }}
        />
        <Tab
          label='Guna Tanah'
          value={2}
          sx={{
            background: 'transparent',
          }}
        />
      </Tabs> */}
      <div
        style={{
          // position: "relative",
          display: 'flex',
          justifyContent: 'center',
          alignCenter: 'center',
          flexDirection: 'column',
          width: '100%',
          // height: 'calc(100% - 80px)', // 80px because there are when position fixed top 70px amd bottom 10px
        }}
      >
        {props.menu === 0 && (
          <>
            <Grid
              container
              component='main'
              // rowSpacing={1}
              // columnSpacing={{xs: 1, sm: 2, md: 2}}
              // mt={2}
              px={2}
              sx={{
                height: '200px',
                borderBottom: '1px solid #BBBBBB',
                margin: '0 !important',
              }}
            >
              <Grid
                item
                xs={6}
                px={2}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingBottom: '8px',
                }}
              >
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: isSmScreen || isXsScreen ? '120px' : '100%',
                  }}
                >
                  <Doughnutchart data={doughnutData} options={options} />
                </div>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  fontSize: '12px',
                  padding: '4px',
                  fontWeight: 'bold',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <div
                  variant='caption'
                  style={{
                    fontSize: '12px',
                  }}
                >
                  {newObj.LuasLadangWord[language]} <br />
                  <b style={{fontSize: '12px'}}>
                    {numberWithCommas(props?.data?.summary?.luas_ladang_ha)} ha
                    / {numberWithCommas(props?.data?.summary?.luas_ladang_ac)}{' '}
                    ac
                  </b>
                </div>

                <br />
                <Grid container component='main'>
                  <Grid item xs={1}>
                    <div className='border red'></div>
                  </Grid>
                  <Grid item xs={11} pl={1}>
                    <div variant='caption' style={{fontSize: '12px'}}>
                      {newObj.LuasBertanamWord[language]} <br />
                      <b className='red' style={{fontSize: '12px'}}>
                        {numberWithCommas(props?.data?.summary?.luas_bertanam)}{' '}
                        ha
                      </b>
                    </div>
                  </Grid>
                </Grid>
                <br />
                <Grid container component='main'>
                  <Grid item xs={1}>
                    <div className='border blue'></div>
                  </Grid>
                  <Grid item xs={11} pl={1}>
                    <div variant='caption' style={{fontSize: '12px'}}>
                      {newObj.LuasBerhasilWord[language]} <br />
                      <b className='blue' style={{fontSize: '12px'}}>
                        {numberWithCommas(props?.data?.summary?.luas_berhasil)}{' '}
                        ha
                      </b>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* Peserta & Lot */}
            <Grid
              container
              sx={{
                padding: '25px',
                borderBottom: '1px solid #BBBBBB',
              }}
            >
              <Grid
                container
                component='main'
                style={{
                  fontSize: '12px',
                  padding: '10px 20px',
                  background: '#2B5180',
                  borderRadius: '10px',
                }}
              >
                <Grid item xs={6}>
                  <div style={{display: 'flex'}}>
                    <img
                      src={IconPesertaLot}
                      alt=''
                      style={{
                        width: '25px',
                        height: '25px',
                        marginRight: '20px',
                      }}
                    />
                    <div>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                        }}
                      >
                        Peserta
                      </p>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                        }}
                      >
                        Lot
                      </p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <div>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                          fontWeight: 'bold',
                        }}
                      >
                        {props?.data?.summary?.peserta}
                      </p>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                          fontWeight: 'bold',
                        }}
                      >
                        {props?.data?.summary?.lot}
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {/* Total Blok */}
            <Grid
              container
              sx={{
                padding: '10px 25px',
                borderBottom: '1px solid #BBBBBB',
              }}
            >
              <Grid item xs={12} display='flex' alignItems='center'>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      width: '50%',
                      fontSize: '10.5px',
                    }}
                  >
                    Blok
                  </div>
                  <div
                    style={{
                      width: '50%',
                      fontSize: '10.5px',
                      padding: '2.5px',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      backgroundColor: 'rgba(0,0,0,.2)',
                      borderRadius: '10px',
                    }}
                  >
                    {props?.data?.data[0]?.total_features}
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                container
                component='main'
                sx={{
                  padding: '25px',
                  borderBottom: '1px solid #BBBBBB',
                }}
              >
                <Grid item xs={6} style={{fontSize: '12px', padding: '4px'}}>
                  Bilangan Pokok
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                    fontWeight: 'bold',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.bilangan_pokok)}
                </Grid>

                <Grid item xs={6} style={{fontSize: '12px', padding: '4px'}}>
                  SPH
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                    fontWeight: 'bold',
                  }}
                >
                  {props?.data?.summary?.sph_sawit &&
                    props?.data?.summary?.sph_sawit}
                </Grid>
                {props?.data?.summary?.umur_pokok_tanam_sawit && (
                  <>
                    <Grid
                      item
                      xs={6}
                      style={{fontSize: '12px', padding: '4px'}}
                    >
                      Umur Pokok Tanam Sawit
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        fontSize: '12px',
                        padding: '4px',
                        fontWeight: 'bold',
                      }}
                    >
                      {props?.data?.summary?.umur_pokok_tanam_sawit}
                    </Grid>
                  </>
                )}
                {props?.data?.summary?.umur_pokok_hasil_sawit && (
                  <>
                    <Grid
                      item
                      xs={6}
                      style={{fontSize: '12px', padding: '4px'}}
                    >
                      Umur Pokok Hasil Sawit
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        fontSize: '12px',
                        padding: '4px',
                        fontWeight: 'bold',
                      }}
                    >
                      {props?.data?.summary?.umur_pokok_hasil_sawit}
                    </Grid>
                  </>
                )}
                {props?.data?.summary?.umur_pokok_tanam_getah && (
                  <>
                    <Grid
                      item
                      xs={6}
                      style={{fontSize: '12px', padding: '4px'}}
                    >
                      Umur Pokok Tanam Getah
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        fontSize: '12px',
                        padding: '4px',
                        fontWeight: 'bold',
                      }}
                    >
                      {props?.data?.summary?.umur_pokok_tanam_getah}
                    </Grid>
                  </>
                )}
                {props?.data?.summary?.umur_pokok_hasil_getah && (
                  <>
                    <Grid
                      item
                      xs={6}
                      style={{fontSize: '12px', padding: '4px'}}
                    >
                      Umur Pokok Hasil Getah
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      style={{
                        fontSize: '12px',
                        padding: '4px',
                        fontWeight: 'bold',
                      }}
                    >
                      {props?.data?.summary?.umur_pokok_hasil_getah}
                    </Grid>
                  </>
                )}
              </Grid>
              <InnerComponent data={props} />
              <LowerComponent
                adminIotFlag={props.adminIotFlag}
                rightData={props.rightData}
                adminLintramaxFlag={props.adminLintramaxFlag}
                viewerLintramaxFlag={props.viewerLintramaxFlag}
                viewerIotFlag={props.viewerIotFlag}
                adminDigitalMapFlag={props.adminDigitalMapFlag}
                viewerDigitalMapFlag={props.viewerDigitalMapFlag}
                kawasan={props.kawasan}
                status={props.status}
                data={props.data}
                pic={props.data.pic}
              />
            </Grid>
          </>
        )}
        {props.menu === 1 && (
          <>
            <Grid
              container
              component='main'
              // rowSpacing={1}
              // columnSpacing={{xs: 1, sm: 2, md: 2}}
              // mt={2}
              px={2}
              sx={{
                height: '200px',
                borderBottom: '1px solid #BBBBBB',
                margin: '0 !important',
              }}
            >
              <Grid
                item
                xs={6}
                px={2}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingBottom: '8px',
                }}
              >
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: isSmScreen || isXsScreen ? '120px' : '100%',
                  }}
                >
                  <Doughnutchart data={doughnutData} options={options} />
                </div>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  fontSize: '12px',
                  padding: '4px',
                  fontWeight: 'bold',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <div variant='caption' style={{fontSize: '12px'}}>
                  {newObj.LuasLadangWord[language]} <br />
                  <b style={{fontSize: '12px'}}>
                    {numberWithCommas(props?.data?.summary?.luas_ladang_ha)} ha
                    / {numberWithCommas(props?.data?.summary?.luas_ladang_ac)}{' '}
                    ac
                  </b>
                </div>

                <br />
                <Grid container component='main'>
                  <Grid item xs={1}>
                    <div className='border blue'></div>
                  </Grid>
                  <Grid item xs={11} pl={1}>
                    <div variant='caption' style={{fontSize: '12px'}}>
                      Luas Jalan <br />
                      <b className='blue' style={{fontSize: '12px'}}>
                        {numberWithCommas(props?.data?.summary?.luas_jalan)} ha
                      </b>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* Peserta & Lot */}
            <Grid
              container
              sx={{
                padding: '25px',
                borderBottom: '1px solid #BBBBBB',
              }}
            >
              <Grid
                container
                component='main'
                style={{
                  fontSize: '12px',
                  padding: '10px 20px',
                  background: '#2B5180',
                  borderRadius: '10px',
                }}
              >
                <Grid item xs={6}>
                  <div style={{display: 'flex'}}>
                    <img
                      src={IconPesertaLot}
                      alt=''
                      style={{
                        width: '25px',
                        height: '25px',
                        marginRight: '20px',
                      }}
                    />
                    <div>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                        }}
                      >
                        Peserta
                      </p>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                        }}
                      >
                        Lot
                      </p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <div>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                          fontWeight: 'bold',
                        }}
                      >
                        {props?.data?.summary?.peserta}
                      </p>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                          fontWeight: 'bold',
                        }}
                      >
                        {props?.data?.summary?.lot}
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {/* Total Blok */}
            <Grid
              container
              sx={{
                padding: '10px 25px',
                borderBottom: '1px solid #BBBBBB',
              }}
            >
              <Grid item xs={12} display='flex' alignItems='center'>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      width: '50%',
                      fontSize: '10.5px',
                    }}
                  >
                    Blok
                  </div>
                  <div
                    style={{
                      width: '50%',
                      fontSize: '10.5px',
                      padding: '2.5px',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      backgroundColor: 'rgba(0,0,0,.2)',
                      borderRadius: '10px',
                    }}
                  >
                    {props?.data?.data[0]?.features.length}
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              sx={
                {
                  // overflowY: 'scroll',
                  // height: "45vh",
                }
              }
            >
              <Grid
                container
                component='main'
                sx={{
                  borderBottom: '1px solid #BBBBBB',
                  padding: '25px',
                }}
              >
                {/* LUAS LADANG */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  {newObj.LuasLadangWord[language]}
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                    fontWeight: 'bold',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.luas_ladang_ha)} ha /{' '}
                  {numberWithCommas(props?.data?.summary?.luas_ladang_ac)} ac
                </Grid>
                {/* LUAS JALAN */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  Luas Jalan
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                    fontWeight: 'bold',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.luas_jalan)} ha
                </Grid>
                {/* KEPADATAN JALAN */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  Kepadatan Jalan
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '4px',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.kepadatan_jalan)} m/ha
                </Grid>
                <br />
                <br />
                {/*  JALAN DALAM BLOK */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  Jalan Dalam Blok
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '4px',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.jalan_dalam_block)} m
                </Grid>
                {/*  JALAN UTAMA */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  Jalan Utama
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '4px',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.jalan_utama)} m
                </Grid>
                {/*  JALAN LADANG */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  Jalan Ladang
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '4px',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.jalan_ladang)} m
                </Grid>
              </Grid>
              <InnerComponent data={props} />

              <LowerComponent
                adminIotFlag={props.adminIotFlag}
                rightData={props.rightData}
                adminLintramaxFlag={props.adminLintramaxFlag}
                viewerLintramaxFlag={props.viewerLintramaxFlag}
                viewerIotFlag={props.viewerIotFlag}
                adminDigitalMapFlag={props.adminDigitalMapFlag}
                viewerDigitalMapFlag={props.viewerDigitalMapFlag}
                kawasan={props.kawasan}
                status={props.status}
                pic={props.data.pic}
              />
            </Grid>
          </>
        )}
        {props.menu === 2 && (
          <>
            <Grid
              container
              component='main'
              // rowSpacing={1}
              // columnSpacing={{xs: 1, sm: 2, md: 2}}
              // mt={2}
              px={2}
              sx={{
                height: '200px',
                borderBottom: '1px solid #BBBBBB',
                margin: '0 !important',
              }}
            >
              <Grid
                item
                xs={6}
                px={2}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingBottom: '8px',
                }}
              >
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: isSmScreen || isXsScreen ? '120px' : '100%',
                  }}
                >
                  <Doughnutchart data={doughnutData} options={options} />
                </div>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  fontSize: '12px',
                  padding: '4px',
                  fontWeight: 'bold',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <div variant='caption' style={{fontSize: '12px'}}>
                  {newObj.LuasLadangWord[language]} <br />
                  <b style={{fontSize: '12px'}}>
                    {numberWithCommas(props?.data?.summary?.luas_ladang_ha)} ha
                    /{numberWithCommas(props?.data?.summary?.luas_ladang_ac)} ac
                  </b>
                </div>

                <br />
                <Grid container component='main'>
                  <Grid item xs={1}>
                    <div className='border blue'></div>
                  </Grid>
                  <Grid item xs={11} pl={1}>
                    <div variant='caption' style={{fontSize: '12px'}}>
                      Luas Tidak Usaha <br />
                      <b
                        className='blue'
                        style={{fontSize: '12px', fontWeight: 'bold'}}
                      >
                        {numberWithCommas(
                          props?.data?.summary?.luas_tidak_usaha
                        )}{' '}
                        ha
                      </b>
                    </div>
                  </Grid>
                </Grid>
                <br />
                <Grid container component='main'>
                  <Grid item xs={1}>
                    <div className='border red'></div>
                  </Grid>
                  <Grid item xs={11} pl={1}>
                    <div variant='caption' style={{fontSize: '12px'}}>
                      Luas Jalan <br />
                      <b className='red' style={{fontSize: '12px'}}>
                        {numberWithCommas(props?.data?.summary?.jalan)} ha
                      </b>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* Peserta & Lot */}
            <Grid
              container
              sx={{
                padding: '25px',
                borderBottom: '1px solid #BBBBBB',
              }}
            >
              <Grid
                container
                component='main'
                style={{
                  fontSize: '12px',
                  padding: '10px 20px',
                  background: '#2B5180',
                  borderRadius: '10px',
                }}
              >
                <Grid item xs={6}>
                  <div style={{display: 'flex'}}>
                    <img
                      src={IconPesertaLot}
                      alt=''
                      style={{
                        width: '25px',
                        height: '25px',
                        marginRight: '20px',
                      }}
                    />
                    <div>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                        }}
                      >
                        Peserta
                      </p>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                        }}
                      >
                        Lot
                      </p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <div>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                          fontWeight: 'bold',
                        }}
                      >
                        {props?.data?.summary?.peserta}
                      </p>
                      <p
                        style={{
                          lineHeight: '22px',
                          fontSize: '12px',
                          color: 'white',
                          fontWeight: 'bold',
                        }}
                      >
                        {props?.data?.summary?.lot}
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {/* Total Blok */}
            <Grid
              container
              sx={{
                padding: '10px 25px',
                borderBottom: '1px solid #BBBBBB',
              }}
            >
              <Grid item xs={12} display='flex' alignItems='center'>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      width: '50%',
                      fontSize: '10.5px',
                    }}
                  >
                    Blok
                  </div>
                  <div
                    style={{
                      width: '50%',
                      fontSize: '10.5px',
                      padding: '2.5px',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      backgroundColor: 'rgba(0,0,0,.2)',
                      borderRadius: '10px',
                    }}
                  >
                    {props?.data?.data[0]?.features.length}
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              sx={
                {
                  // overflowY: 'scroll',
                  // height: "45vh",
                }
              }
            >
              <Grid
                container
                component='main'
                sx={{
                  height: 'fit-content',
                  borderBottom: '1px solid #BBBBBB',
                  fontSize: '12px',
                  padding: '25px',
                }}
              >
                {/* LUAS LADANG */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  {newObj.LuasLadangWord[language]}
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                    fontWeight: 'bold',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.luas_ladang_ha)} ha /{' '}
                  {numberWithCommas(props?.data?.summary?.luas_ladang_ac)} ac
                </Grid>
                {/* LUAS TIDAK USAHA */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  Luas Tidak Usaha
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                    fontWeight: 'bold',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.luas_tidak_usaha)} ha
                </Grid>
                {/* Jalan */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  Luas Jalan
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    padding: '4px',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.jalan)} ha
                </Grid>
                {/* MAJU LUAR KAWASAN */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  Maju Luar Kawasan
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                    fontWeight: 'bold',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.maju_luar_kawasan)} ha
                </Grid>
                {/* LUAS BERHASIL */}
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                  }}
                >
                  {newObj.LuasBerhasilWord[language]}
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    fontSize: '12px',
                    padding: '4px',
                    fontWeight: 'bold',
                  }}
                >
                  {numberWithCommas(props?.data?.summary?.luas_berhasil)} ha
                </Grid>
              </Grid>
              <InnerComponent data={props} />

              <LowerComponent
                adminIotFlag={props.adminIotFlag}
                rightData={props.rightData}
                adminLintramaxFlag={props.adminLintramaxFlag}
                viewerLintramaxFlag={props.viewerLintramaxFlag}
                viewerIotFlag={props.viewerIotFlag}
                adminDigitalMapFlag={props.adminDigitalMapFlag}
                viewerDigitalMapFlag={props.viewerDigitalMapFlag}
                kawasan={props.kawasan}
                status={props.status}
                pic={props.data.pic}
              />
            </Grid>
          </>
        )}
      </div>
    </Box>
  );
}
